import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Body1, Paper } from "@activecollab/components";
import { Page } from "~/components/Page";
import { showErrorToast, showSuccessToast } from "~/components/Toast";
import { completeBillingOrder, editBillingOrder, fetchBillingOrder } from "~/store/actions/actions.billingOrder";
import Angie from "~/utils/angie";
import { assets_url } from "~/utils/urls";

const AuthenticationProcessingPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchBillingOrder()).then(() => {
      dispatch(completeBillingOrder())
        .then((result) => {
          if (result.error) {
            dispatch(editBillingOrder());
            showErrorToast(result.response.message);
            Angie.logger.error("3D Secure authentication failed.", {
              error: result.error,
            });
            navigate("../");
          }

          if (result.response.is_paid) {
            showSuccessToast("Card authenticated and payment successfully processed");
            navigate("../");
          }
        })
        .catch((error) => {
          dispatch(editBillingOrder());
          showErrorToast("3D Secure authentication failed.");
          Angie.logger.error("3D Secure authentication failed.", {
            error: error,
          });
          navigate("../");
        });
    });
  }, [dispatch, navigate]);

  return (
    <Page title="Authentication Processing">
      <Page.Body>
        <Paper
          type="paper-2"
          className="tw-mx-auto tw-mb-4 tw-mt-8 tw-w-[984px] tw-min-w-[644px]"
        >
          <div className="tw-flex tw-flex-col tw-items-center">
            <img
              src={`${assets_url}/subscription/images/processing.png`}
              alt="Authentication Processing image"
              className="tw-my-16"
            />
            <Body1 className="tw-mb-8">Payment processing...</Body1>
          </div>
        </Paper>
      </Page.Body>
    </Page>
  );
};

export default AuthenticationProcessingPage;
